import React, { useEffect, useState } from "react";
import {
  ArticleSection,
  ArticleItemList,
  ArticleListContainer,
  ChapterTitle,
  IconContainer,
  ArticleListWrapper,
} from "./styles";
import { AiFillPrinter } from "react-icons/ai";
import { VscArrowRight } from "react-icons/vsc";
import {
  getManualTopicList,
  printChapter,
} from "../../../redux/modules/eventManual/action";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import EventManualHeader from "../EventManualHomepage/Header";
import ManualSidebar from "../sidebar";
import { Container } from "../styles";
import GeneratePdf from "../GeneratePDF";
import useNotification from "../../../hooks/newUXNotification";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const ArticleList = () => {
  const [isPrinting, setIsPrinting] = useState(false);
  const history = useHistory();
  const { chapterData, topics, loadedTopics } = useSelector(
    (state) => state.eventManual
  );
  const { chapterId } = useParams();
  const dispatch = useDispatch();
  const notification = useNotification();
  const intl = useIntl();
  const { eventEditionCode } = useSelector((state) => state.eventManual);

  useEffect(() => {
    if (chapterId) {
      dispatch(printChapter({ chapterId }));
    }
  }, [chapterId, dispatch]);

  useEffect(() => {
    dispatch(getManualTopicList());
  }, [dispatch]);

  useEffect(() => {
    if (loadedTopics && topics.length === 0) {
      history.push("/checklist");
    }
  }, [history, loadedTopics, topics.length]);

  if (!chapterData) return null;

  const handleGeneratePdf = async (chapter) => {
    if (isPrinting) return;
    setIsPrinting(true);
    try {
      await GeneratePdf({
        data: chapter,
        successMessage: intl.formatMessage({ id: "generating_pdf_success" }),
        waitingMessage: intl.formatMessage({ id: "generating_pdf" }),
      });
    } catch (error) {
      notification.displayInfo(
        intl.formatMessage({ id: "error.PDF_cannot_be_created" })
      );
    } finally {
      setIsPrinting(false);
    }
  };

  return (
    <Container>
      <EventManualHeader topics={topics} />

      <ArticleListWrapper>
        <ManualSidebar topics={topics} />
        <ArticleListContainer>
          <ChapterTitle>
            {chapterData[0].chapterName}{" "}
            <IconContainer onClick={() => handleGeneratePdf(chapterData)}>
              <AiFillPrinter />
            </IconContainer>
          </ChapterTitle>
          <ArticleSection>
            {chapterData.map((chapter, index) => (
              <ArticleItemList
                to={`/event-manual/${eventEditionCode}/chapter/${chapterId}/article/${chapter.articleId}`}
                key={`articleList-${index}`}
              >
                {chapter.articleTitle} <VscArrowRight />
              </ArticleItemList>
            ))}
          </ArticleSection>
        </ArticleListContainer>
      </ArticleListWrapper>
    </Container>
  );
};

export default ArticleList;
